<picture>
  <ng-container *ngIf="picture">
    <source
      *ngFor="let source of picture"
      [media]="source.query.join(' and ')"
      [srcset]="source?.media?.src"
    />
  </ng-container>
  <img
    [attr.src]="media?.src"
    [attr.srcset]="media?.srcset"
    [attr.alt]="media?.alt"
    [attr.loading]="loadingStrategy"
    (load)="loadHandler()"
    (error)="errorHandler()"
  />
</picture>
